import React from 'react';
import { useAppSelector } from '@app/hooks';
import { Trans, useTranslation } from 'react-i18next';
import { AuthPopup } from '@types';
import { selectAppSettings } from '@modules/app';
import { AuthFooter, AuthFooterMessage, AuthLink } from '../components';
import { AuthFooterProps } from '../types';

export const SignInFooter: React.FC<AuthFooterProps> = ({ type, children }) => {
    const { enabled_magic_links } = useAppSelector(selectAppSettings);
    const { t } = useTranslation();

    return (
        <AuthFooter className={enabled_magic_links ? 'flex-col' : undefined}>
            <AuthFooterMessage>
                <Trans
                    i18nKey="messages.signUpLink"
                    components={{
                        ln: <AuthLink auth={AuthPopup.SignUp} type={type} />,
                    }}
                    defaults={'Don’t have an account? <ln>Sign Up</ln>'}
                />
            </AuthFooterMessage>

            {enabled_magic_links && (
                <AuthFooterMessage className="micro-margin-top">
                    <Trans
                        i18nKey="messages.otpLink"
                        components={{
                            ln: <AuthLink auth={AuthPopup.OTP} type={type} />,
                        }}
                        defaults={'Or sign in <ln>with a code</ln>'}
                    />
                </AuthFooterMessage>
            )}

            {children}
        </AuthFooter>
    );
};
